import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Nav } from 'react-bootstrap';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { BorderedBottomTabs, CustomNavLink, NavItem } from '@spark/ui-components/components/Tabs';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useLocation, useParams } from 'react-router-dom';

import { DetalhesTab } from './components/Tabs/Detalhes';
import OperacoesTab from './components/Tabs/Operacoes';
import { EmailsTab } from './components/Tabs/Emails';

const VALID_TABS = [
  'detalhes',
  'operacoes',
  'emails',
];

const getTabFromSearch = (search) => {
  const tab = new URLSearchParams(search).get('tab');
  return VALID_TABS.includes(tab) ? tab : 'detalhes';
};

const ClienteDetalhes = () => {
  const { id } = useParams();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => getTabFromSearch(location.search));

  useEffect(() => {
    const tab = getTabFromSearch(location.search);
    setActiveTab(tab);
  }, [location.search]);

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[
              { name: 'Início' },
              { name: 'Clientes', path: '/pages/clientes' },
              { name: 'Detalhes' },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <Row>
                <Col md={12}>
                  <BorderedBottomTabs className="mb-3">
                    <Nav variant="tabs" className="nav-tabs">
                      <NavItem>
                        <CustomNavLink
                          active={activeTab === 'detalhes'}
                          onClick={() => setActiveTab('detalhes')}
                        >
                          <span className="tab-text">Detalhes</span>
                        </CustomNavLink>
                      </NavItem>

                      <NavItem>
                        <CustomNavLink
                          active={activeTab === 'operacoes'}
                          onClick={() => setActiveTab('operacoes')}
                        >
                          <span className="tab-text">Operações</span>
                        </CustomNavLink>
                      </NavItem>

                      <NavItem>
                        <CustomNavLink
                          active={activeTab === 'emails'}
                          onClick={() => setActiveTab('emails')}
                        >
                          <span className="tab-text">Emails</span>
                        </CustomNavLink>
                      </NavItem>
                    </Nav>
                  </BorderedBottomTabs>
                </Col>
              </Row>

              {activeTab === 'detalhes' && <DetalhesTab />}

              {activeTab === 'operacoes' && <OperacoesTab clienteId={parseInt(id, 10)} />}

              {activeTab === 'emails' && <EmailsTab clienteId={parseInt(id, 10)} />}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ClienteDetalhes;
